import { render, staticRenderFns } from "./setCustomizedContentDrawer.vue?vue&type=template&id=16b5b9eb&scoped=true"
import script from "./setCustomizedContentDrawer.vue?vue&type=script&lang=js"
export * from "./setCustomizedContentDrawer.vue?vue&type=script&lang=js"
import style0 from "./setCustomizedContentDrawer.vue?vue&type=style&index=0&id=16b5b9eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5b9eb",
  null
  
)

export default component.exports